import { createI18n } from 'vue-i18n';

// Import generated translation files from Laravel
// These are auto-generated by `npm run i18n:export`
const messages = import.meta.glob('../locales/**/translations.json', {
  eager: true
});

// Process the imported files into a structure vue-i18n expects
// Example: '../locales/en/translations.json' -> { en: {...} }
const locales = {};

for (const path in messages) {
  const matched = path.match(/\.\.\/locales\/([^/]+)\/translations\.json$/);
  if (matched) {
    const locale = matched[1];
    locales[locale] = messages[path].default || messages[path];
  }
}

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'en', // Default locale (will be updated from Inertia props)
  fallbackLocale: 'en', // Fallback locale
  messages: locales,
  globalInjection: true, // Enable global $t, $tc, etc.
  missingWarn: false, // Disable missing translation warnings in production
  fallbackWarn: false // Disable fallback warnings in production
});

export default i18n;
